import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { useToast } from "../../controller/ToastController";

const knockEmail = "knockcs@ivid.kr";

const ContactModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const showToast = useToast();
  const [lang, setLang] = useRecoilState<number>(langState);
  const qrAuth = useRecoilValue<qrAuthType>(qrAuthState);

  const navigateKakaoLink = () => {
    // window.location.href = `${process.env.REACT_KAKAO_APP_URL}`;
    window.location.href = `kakaoplus://plusfriend/knockmanager`;
    setTimeout(() => {
      // window.location.href = `${process.env.REACT_KAKAO_WEB_URL}`;
      window.location.href = `https://pf.kakao.com/_xhbdBG/chat`;
    }, 500);
  };

  const copyToClipBoardText = () => {
    try {
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(knockEmail);
        showToast(langText.contact_modal_toast_copy[lang]);
      }
    } catch (err) {
      console.log("err", err, knockEmail);
    }
  };

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="contactModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_grey.svg`}
            alt="ic"
          />
          {/* <img
            className="title"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_contact.svg`}
            alt="ic"
          /> */}
          <h3>{langText.contact_modal_title[lang]}</h3>
          <h1>ZERO</h1>
          <h2>{langText.contact_modal_content[lang]}</h2>
          <h5>{langText.customer_service_message[lang]}</h5>
          <div className="contactBox">
            <div className="subtitle" onClick={navigateKakaoLink}>
              <h3>{langText.contact_modal_kakaotalk[lang]}</h3>
              <div className="subItem">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/img/kakaotalk.png`}
                  alt="ic"
                />
              </div>
              <img
                className="arrow"
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_grey.svg`}
                alt="ic"
              />
            </div>
            <div className="subtitle" onClick={copyToClipBoardText}>
              <h3>E-MAIL</h3>
              <div className="subItem">
                <h3>{knockEmail}</h3>
              </div>
            </div>
          </div>
          <h5 className="footer">{langText.contact_modal_footer[lang]}</h5>
          <button className="submitButton" onClick={onCloseModal}>
            {langText.button_confirm[lang]}
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default ContactModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 60px 40px 20px 40px;
    text-align: center;
    position: relative;
  }

  img.title {
    height: 50px;
    padding-bottom: 10px;
  }

  .closeIcon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 400;
  }
  h2 {
    margin: 0 auto;
    width: fit-content;
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    padding: 4px 20px;
    background: #4dd2ae;
    border-radius: 5px;
  }
  h1 {
    margin-top: -10px;
    font-size: 60px;
    line-height: 60px;
    font-weight: 700;
  }
  h5 {
    font-size: 14px;
    line-height: 22px;
    font-weight: 300;
    color: #e5e5e5;
  }
  h5.footer {
    margin-top: -6px;
    color: #4dd2ae;
  }

  .contactBox {
    height: 180px;
    display: flex;
    align-items: center;
    gap: 14px;

    img.arrow {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
    }

    .subtitle {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px 0;
      height: 100%;
      border: 1px solid #555555;
      border-radius: 10px;
      h3 {
        color: #cecece;
        font-weight: 600;
      }

      .subItem {
        display: flex;
        justify-content: center;
        height: 70px;
        img {
          height: 100%;
        }
        h3 {
          font-size: 24px;
          line-height: 32px;
          color: #fff;
        }
      }
    }
  }

  .submitButton {
    display: none;
    position: relative;
    width: 100%;
    padding: 14px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }

  @media (max-width: 700px) {
    .modal {
      gap: 14px;
      padding: 60px 12px 40px 12px;
    }

    .closeIcon {
      top: 16px;
      right: 16px;
    }

    h3 {
      font-size: 16px;
      line-height: 22px;
    }
    h2 {
      font-size: 16px;
      line-height: 22px;
    }
    h1 {
      margin-top: -14px;
    }
    h5 {
      font-size: 12px;
      line-height: 16px;
    }
    h5.footer {
      margin-top: 0;
    }

    .contactBox {
      height: 140px;
      .subtitle {
        padding: 16px 0;
        .subItem {
          height: 50px;
          h3 {
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }

    .submitButton {
      margin-top: -8px;
      display: block;
    }
  }
`;
